import script from "./ship_receive_print_btn.vue?vue&type=script&setup=true&lang=js"
export * from "./ship_receive_print_btn.vue?vue&type=script&setup=true&lang=js"

import "./ship_receive_print_btn.vue?vue&type=style&index=0&id=504dfb84&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-504dfb84"]])

export default __exports__